import { object, nativeEnum } from 'zod';

import { OfferPresentationPriority, OfferPresentationType } from '@ocx/graphql';

export const OfferOverridesSchema = object({
  presentationPriority: nativeEnum(OfferPresentationPriority).optional(),
  presentationType: nativeEnum(OfferPresentationType).optional(),
}).strict();
